import React, { useEffect, useState } from 'react';
import { Target } from 'lucide-react';
import api from '../lib/api';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Progress } from './ui/progress';

export default function QuestionsCountdown() {
  const [countdown, setCountdown] = useState(null);

  useEffect(() => {
    const fetchCountdown = async () => {
      try {
        const response = await api.get("/stats/questions-countdown");
        setCountdown(response.data);
      } catch (error) {
        console.error('Erro:', error);
      }
    };
    fetchCountdown();
    const interval = setInterval(fetchCountdown, 30000);
    return () => clearInterval(interval);
  }, []);

  if (!countdown) return null;

  return (
    <Card className="shadow-md border-2 border-blue-200 dark:border-blue-800" data-testid="questions-countdown">
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-lg text-slate-900 dark:text-slate-100">
          <Target className="w-5 h-5 text-purple-600" />
          Meta Semanal
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="grid grid-cols-3 gap-2 text-center">
          <div>
            <p className="text-2xl font-bold text-purple-600">{countdown.current}</p>
            <p className="text-xs text-slate-500">Feitas</p>
          </div>
          <div>
            <p className="text-2xl font-bold text-blue-600">{countdown.remaining}</p>
            <p className="text-xs text-slate-500">Faltam</p>
          </div>
          <div>
            <p className="text-2xl font-bold text-green-600">{countdown.target}</p>
            <p className="text-xs text-slate-500">Meta</p>
          </div>
        </div>
        <Progress value={Math.min(countdown.progress_percent, 100)} className="h-2" />
        <p className="text-sm text-center text-slate-600 dark:text-slate-400">
          {countdown.progress_percent >= 100 ? 'Meta atingida!' : `${countdown.progress_percent}% concluído`}
        </p>
      </CardContent>
    </Card>
  );
}
